import { render, staticRenderFns } from "./StatisticByQueues.vue?vue&type=template&id=56725cbb&scoped=true&"
import script from "./StatisticByQueues.vue?vue&type=script&lang=js&"
export * from "./StatisticByQueues.vue?vue&type=script&lang=js&"
import style0 from "./StatisticByQueues.vue?vue&type=style&index=0&id=56725cbb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56725cbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VDataTable,VProgressLinear})
